// File: SimulatorItem.js
import React, { useMemo, useState } from "react";
import { Card, Image, Button, Icon, Label, Confirm } from "semantic-ui-react";
import { BasicModal } from "../../../Shared";
import { simulatorApi } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { SimulatorForm } from "../SimulatorForm";
import "./SimulatorItem.scss";

export function SimulatorItem({ simulator, onReload }) {
  const { accessToken } = useAuth();
  const [showModalForm, setShowModalForm] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showDesc, setShowDesc] = useState(false);

  const toggleForm = () => setShowModalForm((v) => !v);
  const toggleConfirm = () => setShowConfirm((v) => !v);
  const toggleDesc = () => setShowDesc((v) => !v);

  const imgSrc =
    simulator.miniature || "https://via.placeholder.com/800x450?text=Simulator";
  const shortDesc = useMemo(
    () => (simulator.description || "").trim(),
    [simulator.description],
  );

  const onDelete = async () => {
    try {
      await simulatorApi.deleteSimulator(accessToken, simulator._id);
      onReload?.();
    } catch (e) {
      console.error(e);
    } finally {
      toggleConfirm();
    }
  };

  return (
    <>
      {/* Card con ancho fijo controlado por SCSS; no se deforma */}
      <Card className="sim-card" raised>
        <div className="sim-card__thumb" aria-hidden="true">
          {/* La imagen respeta el 16/9 con object-fit: cover */}
          <Image
            src={imgSrc}
            alt={simulator.title || "Simulator"}
            wrapped
            ui={false}
          />
          <div className="sim-card__actions">
            <Button
              icon
              size="tiny"
              color="orange"
              onClick={toggleForm}
              title="Editar"
              aria-label="Editar simulador"
            >
              <Icon name="pencil" />
            </Button>
            <Button
              icon
              size="tiny"
              color="red"
              onClick={toggleConfirm}
              title="Eliminar"
              aria-label="Eliminar simulador"
            >
              <Icon name="trash" />
            </Button>
          </div>
        </div>

        <Card.Content className="sim-card__body">
          <Card.Header title={simulator.title}>
            {simulator.title || "(Sin título)"}
          </Card.Header>

          {!!simulator.idServer && (
            <Card.Meta>
              <Label size="mini" basic>
                Server: {simulator.idServer}
              </Label>
            </Card.Meta>
          )}

          <Card.Meta className="sim-card__id">{simulator._id}</Card.Meta>

          {shortDesc ? (
            <div className="sim-card__desc">
              <p className="line-clamp">{shortDesc}</p>
              <Button
                icon
                size="mini"
                basic
                className="sim-card__readmore"
                title="Leer descripción completa"
                aria-label="Leer descripción completa"
                onClick={toggleDesc}
              >
                <Icon name="align left" />
              </Button>
            </div>
          ) : (
            <div className="sim-card__desc--empty">Sin descripción</div>
          )}
        </Card.Content>
      </Card>

      <BasicModal
        show={showModalForm}
        close={toggleForm}
        title={`Editando ${simulator.title || ""}`}
      >
        <SimulatorForm
          onClose={toggleForm}
          onReload={onReload}
          simulator={simulator}
        />
      </BasicModal>

      <BasicModal
        show={showDesc}
        close={toggleDesc}
        title={simulator.title || "Descripción"}
      >
        <div className="sim-card__desc-full">
          {shortDesc ? <p>{shortDesc}</p> : <p>(Sin descripción)</p>}
        </div>
      </BasicModal>

      <Confirm
        open={showConfirm}
        size="mini"
        onCancel={toggleConfirm}
        onConfirm={onDelete}
        content={`Eliminar el simulador "${simulator.title}"`}
      />
    </>
  );
}
